import script from "./ArticleGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleGenerator.vue?vue&type=script&setup=true&lang=js"

import "./ArticleGenerator.vue?vue&type=style&index=0&id=5a299278&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a299278"]])

export default __exports__